import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import { useTranslation } from "react-i18next"; // Import useTranslation

const ChatPlaceholder = (props) => {
  const { t } = useTranslation(); // Use the translation hook

  if (props.display) {
    return null;
  }

  return (
    <Box
      sx={{
        height: "80vh",
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "transparent",
        borderRadius: 2,
        p: 4,
        textAlign: "center",
      }}
    >
      {/* Hero Section */}
      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            color: "#1976d2",
            mb: 2,
          }}
        >
          {t("chat_placeholder.welcome")} {/* Translated "Welcome to Chat" */}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: "#666",
            maxWidth: "600px",
            mx: "auto",
            fontFamily: "Poppins",
          }}
        >
          {t("chat_placeholder.select_conversation")} {/* Translated "Select a conversation..." */}
        </Typography>
      </Box>

      {/* Features Grid */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: 4,
          width: "100%",
          maxWidth: "900px",
          mb: 6,
        }}
      >
        {/* Feature 1 */}
        <Box
          sx={{
            p: 3,
            bgcolor: "#f8f9fa",
            borderRadius: 2,
            transition: "transform 0.2s",
            "&:hover": { transform: "translateY(-4px)" },
          }}
        >
          <ChatBubbleOutlineIcon
            sx={{ fontSize: 40, color: "#1976d2", mb: 2 }}
          />
          <Typography variant="h6" sx={{ mb: 1, fontFamily: "Poppins" }}>
            {t("chat_placeholder.real_time_chat")} {/* Translated "Real-time Chat" */}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontFamily: "Poppins" }}>
            {t("chat_placeholder.real_time_chat_description")} {/* Translated description */}
          </Typography>
        </Box>

        {/* Feature 2 */}
        <Box
          sx={{
            p: 3,
            bgcolor: "#f8f9fa",
            borderRadius: 2,
            transition: "transform 0.2s",
            "&:hover": { transform: "translateY(-4px)" },
          }}
        >
          <PeopleAltOutlinedIcon
            sx={{ fontSize: 40, color: "#1976d2", mb: 2 }}
          />
          <Typography variant="h6" sx={{ mb: 1, fontFamily: "Poppins" }}>
            {t("chat_placeholder.group_chats")} {/* Translated "Group Chats" */}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontFamily: "Poppins" }}>
            {t("chat_placeholder.group_chats_description")} {/* Translated description */}
          </Typography>
        </Box>

        {/* Feature 3 */}
        <Box
          sx={{
            p: 3,
            bgcolor: "#f8f9fa",
            borderRadius: 2,
            transition: "transform 0.2s",
            "&:hover": { transform: "translateY(-4px)" },
          }}
        >
          <SecurityOutlinedIcon
            sx={{ fontSize: 40, color: "#1976d2", mb: 2 }}
          />
          <Typography variant="h6" sx={{ mb: 1, fontFamily: "Poppins" }}>
            {t("chat_placeholder.secure")} {/* Translated "Secure" */}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontFamily: "Poppins" }}>
            {t("chat_placeholder.secure_description")} {/* Translated description */}
          </Typography>
        </Box>
      </Box>

      {/* Call-to-action Button */}
      {/* <Button
        variant="contained"
        size="large"
        sx={{
          px: 4,
          py: 1.5,
          borderRadius: 2,
          textTransform: "none",
          fontSize: "1.1rem",
          fontWeight: 500,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          "&:hover": {
            boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
          },
        }}
      >
        {t("chat_placeholder.start_messaging")} 
      </Button> */}
    </Box>
  );
};

export default ChatPlaceholder;